// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".shortText{word-break:break-word}.hiddenText{display:inline-block}.hiddenText div{padding:5px 0;word-break:break-word}", ""]);
// Exports
module.exports = exports;
